import { OfferData } from '../../core/domain/offerData.model'
import { OfferSummaryData } from './Summary.model'

export const summaryViewMapper = (offer: OfferData) => {
  const offerView: OfferSummaryData = {
    vehicles: offer.vehiclesToEnsure,
    globalInsured: offer.globalInsured,
    plate1: offer.plate1,
    plate2: offer.plate2,
    plate3: offer.plate3,
    plate4: offer.plate4,
    plate5: offer.plate5,
    insuredVehicle1: offer.insuredVehicle1,
    insuredVehicle2: offer.insuredVehicle2,
    insuredVehicle3: offer.insuredVehicle3,
    insuredVehicle4: offer.insuredVehicle4,
    insuredVehicle5: offer.insuredVehicle5,
    deductible: offer.deductible,
    transCH: offer.transCH,
    transEurope: offer.transEurope,
    transRemoval: offer.transRemoval,
    transTheft: offer.transTheft,
    liability: offer.liability,
  }
  return offerView
}
